import React, { useState } from 'react';


const OrderDetailsTab = () => {
  const [activeTab, setActiveTab] = useState('details');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="order-details-tab">
      <div className={`tab ${activeTab === 'details' ? 'active' : ''}`} onClick={() => handleTabClick('details')}>
        Details
      </div>
      <div className={`tab ${activeTab === 'activity' ? 'active' : ''}`} onClick={() => handleTabClick('activity')}>
        Activity Log
      </div>
    <div className='order-details-tab-divider'></div>
      <div className="tab-content">
        {activeTab === 'details' && (
        <div className="details-content">
            <section className='flex '>
                <section className='flex flex-col order-details-section-container'>
                    <p className='details-title mt-8'>Requested service(s)</p>
                    <section className='flex requested-service-container mt-6'>
                        <div className='flex flex-col gap-8'>
                            <p className='requested-service-title'>Item/Service</p>
                            <p className='requested-service-subtitle'>Wash N Fold</p>
                            <p className='requested-service-subtitle'>Rug</p>
                            <p className='requested-service-subtitle'>Pillows</p>
                        </div>
                        <div className='flex flex-col gap-8'>
                            <p className='requested-service-title'>Quantity</p>
                            <p className='requested-service-subtitle'>11lbs</p>
                            <p className='requested-service-subtitle'>8</p>
                            <p className='requested-service-subtitle'>12</p>
                        </div>
                        <div className='flex flex-col gap-8'>
                            <p className='requested-service-title'>Price</p>
                            <p className='requested-service-subtitle'>$ 89.00</p>
                            <p className='requested-service-subtitle'>$ 230.00</p>
                            <p className='requested-service-subtitle'>$ 100.00</p>
                        </div>
                    </section>
                    <section>
                        <div className='flex flex-col mt-10'>
                            <p className='notes-title'>Notes</p>
                            <p className='notes-content mt-5'>Client is very straightforward about his products, he loves clean efficient installation and stress-free regular maintenance.</p>
                        </div>
                        

                    </section>
                    <div className='order-details-divider'></div>
                    <section className='flex mt-10 gap-52'>
                        <div className='flex flex-col gap-10'>
                            <p className='order-details-payment-preference-title'>Payment preference</p>
                            <p className='order-details-payment-preference-subtitle'>Pay at pickup</p>
                        </div>
                        <div className='flex flex-col gap-10'>
                            <p className='order-details-payment-preference-title'>Payment option</p>
                            <p className='order-details-payment-preference-subtitle'>cash</p>
                        </div>

                    </section>
                </section>
                <section className='flex gap-96 pl-10'>
                    <div className='flex flex-col gap-10'>
                        <p className='payment-summary-title'>Subtotal</p>
                        <p className='payment-summary-title'>Tip</p>
                        <p className='payment-summary-title'>Amount Paid</p>
                        <p className='payment-summary-title'>Outstanding</p>
                    </div>
                    <div className='flex flex-col gap-10'>
                        <p className='payment-summary-subtitle'>$ 419.00</p>
                        <p className='payment-summary-subtitle'>$ 0.00</p>
                        <p className='payment-summary-subtitle'>$ 0.00</p>
                        <p className='payment-summary-subtitle'>$ 419.00</p>
                    </div>
                </section>
            </section>
            
            
        </div>
          
        )}

        {activeTab === 'activity' && (
          <div className="activity-content">
            {/* Activity log layout */}
            <section>
                <div>
                    <div className='activity-log-day-bg'>
                        <p className='activity-log-day-text'>Today</p>
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-time-text'>13:28 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>                    
                </div>
                <div>
                    <div className='activity-log-day-bg'>
                        <p className='activity-log-day-text'>Today</p>
                    </div>
                    <div className='activity-log-content-bg'>
                        <p className='activity-log-day-text'>13:28 <span className='activity-log-day-details ml-4'>Angela set status to washing </span></p>
                        
                    </div>                    
                </div>
            </section>
            

          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDetailsTab;
